import _ from 'lodash'
import * as actionTypes from './actionTypes'
import { getAxios } from '../../lib/projectAxios'
import uuid from 'uuid/v4'
import { fromJS, List, Map } from 'immutable'
import { getPageUID, IS_DATA_CONTAINER } from '../../lib/getValueByType'

const axios = getAxios()

export const processPaymentIntegration = (params) => async (dispatch, getState) => {
  if (!params.actionID) {
    return false
  }

  if (params.actionID == 'clear-stripe-requests') {
    try {
      let result = await axios.post('/webprojects/payment/refresh')
    } catch (err) {
      console.log('err >>> ', err)
    }
    return true
  }

  let state = getState()

  let pushList = state.getIn(['project', 'Settings', 'pushToSalesforce'])
  let isTransactionObject = false
  if (pushList) {
    pushList.map((sfItem) => {
      if (sfItem && sfItem.get('isTransactionObject')) {
        isTransactionObject = true
      }
    })
  }

  if (isTransactionObject) {
    let retState = getState()
    retState = retState.setIn(['widgets', 'isShowPaymentModal'], true)
    retState = retState.setIn(['widgets', 'selectedCustomService'], params.actionID)
    dispatch({
      type: actionTypes.SET_STORE,
      payload: {
        store: retState,
      },
    })
    return false
  }

  let message = ''

  if (params.actionID) {
    if (state.getIn(['project', 'Settings', 'store', 'public', params.actionID, 'preloaderMessage'])) {
      message = state.getIn(['project', 'Settings', 'store', 'public', params.actionID, 'preloaderMessage'])
    }
  }

  dispatch({
    type: actionTypes.SHOW_LOADING_WINDOW,
    payload: {
      messages: [message],
      clientY: _.get(params, ['currentRule', 'options', 'clientY']),
    },
  })

  let pageUID = getPageUID(state.get('page'), state.getIn(['project', 'Pages']))
  let pageFields = state.getIn(['state', pageUID], Map()).toJS()
  let elements = state.getIn(['pages', state.get('page'), 'Props', 'elements'], Map())
  let pageParams = state.getIn(['pages', state.get('page'), 'Props', 'params'], Map()).toJS()
  let checkoutForm = state.getIn(['state', 'eCommerce', 'checkoutForm'], Map()).toJS()
  let pageData = {},
    pageParamsValues = {}

  _.each(pageParams, function (row) {
    if (row && row.id) {
      pageParamsValues[row.id] = state.getIn(['state', pageUID, row.id])
      _.set(pageData, [row.id], state.getIn(['state', pageUID, row.id]))
    }
  })

  _.each(pageFields, function (val, uid) {
    if (IS_DATA_CONTAINER.includes(elements.getIn([uid, 'type']))) {
      pageData[uid] = val
    } else if (elements.getIn([uid, 'type']) == 'Strip' || elements.getIn([uid, 'type']) === 'RepeatAutoFit') {
      if (elements.getIn([uid, 'props', 'isRepeat']) || elements.getIn([uid, 'props', 'isRepeatCol'])) {
        if (val && _.isObject(val)) {
          _.each(val, function (val2, elemUID) {
            let fieldType = elements.getIn([elemUID, 'type'])
            if (!fieldType || IS_DATA_CONTAINER.includes(fieldType)) {
              _.set(pageData, [uid, elemUID], val2)
            }
          })
        }
      }
    }
  })

  let requestData = {
    actionID: params.actionID,
    pageUID: pageUID,
    params: state.getIn(['params'], Map()).toJS(),
    page: pageData,
    pageParams: pageParamsValues,
    checkoutForm,
  }

  const recursiveProcessGet = async (attemp) => {
    if (attemp >= 3) {
      return {
        status: 200,
        data: {
          status: false,
        },
      }
    }
    try {
      let result = await axios.post('/webprojects/payment/integration', requestData)
      return result
    } catch (err) {
      console.log('err >>> ', err)
      await new Promise((resolve) => {
        setTimeout(resolve, 2 * 1000)
      })

      return recursiveProcessGet(attemp + 1)
    }
  }

  let { status, data } = await recursiveProcessGet(0)

  if (!(window.ft_stripe_element && window.ft_stripe_element.stripe)) {
    dispatch({
      type: actionTypes.CLOSE_LOADING_WINDOW,
    })
  }

  if (data.status) {
    let retState = getState()
    retState = retState.setIn(['widgets', 'isShowPaymentModal'], true)
    retState = retState.setIn(['widgets', 'selectedCustomService'], params.actionID)
    retState = retState.setIn(['widgets', 'clientY', 'payment'], _.get(params, ['currentRule', 'options', 'clientY']))
    if (!data.transaction) {
      data.transaction = {}
    }
    data.transaction.currentRule = params.currentRule
    retState = retState.setIn(['state', 'eCommerce', 'transaction'], fromJS(data.transaction))

    dispatch({
      type: actionTypes.SET_STORE,
      payload: {
        store: retState,
      },
    })
  }
}
